import classNames from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';

import { useStateTabContext } from './Tab';

export type TabItemProps = {
  children: ReactNode;
  tabId: number | string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  id?: string;
};

const TabItem = ({ children, tabId, onClick, id }: TabItemProps) => {
  const { currentTab } = useStateTabContext();

  const active = currentTab === tabId;

  const classes = classNames('inline-block rounded-t-lg py-2 px-4', {
    'text-emblue-primary border-b-emblue-primary border-b-2': active,
  });

  return (
    <li id={id}>
      <button aria-current="page" className={classes} onClick={onClick}>
        {children}
      </button>
    </li>
  );
};

export default TabItem;
